/**
 * @flow
 * @relayHash ece93762c9c4b404bd29b97adfd4ccc7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type WMMobileLeaderboard_getLonewolfPersonalLeaderboardData$ref = any;
export type WMMobileLeaderboardRefetchQueryVariables = {|
  event_token: string,
  guest_token: string,
  quarter_id: number,
  page_number?: ?number,
  search_val?: ?string,
|};
export type WMMobileLeaderboardRefetchQueryResponse = {|
  +$fragmentRefs: WMMobileLeaderboard_getLonewolfPersonalLeaderboardData$ref
|};
export type WMMobileLeaderboardRefetchQuery = {|
  variables: WMMobileLeaderboardRefetchQueryVariables,
  response: WMMobileLeaderboardRefetchQueryResponse,
|};
*/


/*
query WMMobileLeaderboardRefetchQuery(
  $event_token: String!
  $guest_token: String!
  $quarter_id: Int!
  $page_number: Int
  $search_val: String
) {
  ...WMMobileLeaderboard_getLonewolfPersonalLeaderboardData_4fXuCo
}

fragment WMMobileLeaderboard_getLonewolfPersonalLeaderboardData_4fXuCo on Query {
  getLonewolfPersonalLeaderboardData(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id, page_number: $page_number, search_val: $search_val) {
    data {
      leaderboard {
        name
        points
        position
      }
      total_page
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "event_token",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "guest_token",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "quarter_id",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "page_number",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search_val",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "event_token",
    "variableName": "event_token"
  },
  {
    "kind": "Variable",
    "name": "guest_token",
    "variableName": "guest_token"
  },
  {
    "kind": "Variable",
    "name": "page_number",
    "variableName": "page_number"
  },
  {
    "kind": "Variable",
    "name": "quarter_id",
    "variableName": "quarter_id"
  },
  {
    "kind": "Variable",
    "name": "search_val",
    "variableName": "search_val"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "WMMobileLeaderboardRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "WMMobileLeaderboard_getLonewolfPersonalLeaderboardData",
        "args": (v1/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "WMMobileLeaderboardRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "getLonewolfPersonalLeaderboardData",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "lonewolfPersonalLeaderboardDataType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "data",
            "storageKey": null,
            "args": null,
            "concreteType": "lonewolfPersonalLeaderboardResult",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "leaderboard",
                "storageKey": null,
                "args": null,
                "concreteType": "lonewolfPositionsType",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "points",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "position",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "total_page",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "WMMobileLeaderboardRefetchQuery",
    "id": null,
    "text": "query WMMobileLeaderboardRefetchQuery(\n  $event_token: String!\n  $guest_token: String!\n  $quarter_id: Int!\n  $page_number: Int\n  $search_val: String\n) {\n  ...WMMobileLeaderboard_getLonewolfPersonalLeaderboardData_4fXuCo\n}\n\nfragment WMMobileLeaderboard_getLonewolfPersonalLeaderboardData_4fXuCo on Query {\n  getLonewolfPersonalLeaderboardData(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id, page_number: $page_number, search_val: $search_val) {\n    data {\n      leaderboard {\n        name\n        points\n        position\n      }\n      total_page\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '589c90bdaf89779ed11f9fd044d9d607';
module.exports = node;
